export default __webpack_public_path__ + "static/media/Git_-_adamr.space___Codecademy.4555d07e.pdf";